import jquery from "jquery";

var headerHeight = 90;
jquery(".js-glide-slider").height(
  window.innerWidth < 768
    ? window.innerHeight - headerHeight
    : window.innerHeight -
        (jquery(".js-glide-slider")
          .siblings(".container")
          .height() +
          (headerHeight + 60))
);

window.addEventListener("resize", function() {
  if (window.innerWidth < 768) {
    jquery(".js-glide-slider").height(window.innerHeight - headerHeight);
  } else {
    jquery(".js-glide-slider").height(
      window.innerHeight -
        (jquery(".js-glide-slider")
          .siblings(".container")
          .height() +
          (headerHeight + 100))
    );
  }
});
